import React, { useState } from 'react';

const HeaderContext = React.createContext();

const HeaderProvider = (props) => {
    const defaultHeaderClass = 'page-header-img';

    const INITIAL_STATE = {
        headerClass: defaultHeaderClass
    }

    const [headerState, setHeaderState] = useState(INITIAL_STATE);

    const getHeaderClass = () => {
        return headerState.headerClass;
    }

    const setHeader = (header) => {
        const headerClass = headers[header] || defaultHeaderClass;
        return setHeaderState({ headerClass: headerClass });
    }

    const clearHeader = () => {
        return setHeader('');
    }

    const headers = {
        contractSearch: 'page-header-contract-search-img',
        contractProcessing: 'page-header-contract-processing-img',
        contractDetails: 'page-header-contract-details-img',
        combinedDetails: 'page-header-combined-contract-details-img',
        customerProfile: 'page-header-customer-profile-img',
        reports: 'page-header-reports-img',
        contractQuote: 'page-header-contract-quote-img',
        combinedContractQuote: 'page-header-combined-contract-quote-img',
        formsLibrary: 'page-header-library-img',
        documentUpload: 'page-header-document-upload-img',
        contractDocuments: 'page-header-contract-documents-img'
    };

    return (
        <HeaderContext.Provider 
            value={{ 
                getHeaderClass: getHeaderClass,
                setHeader: setHeader,
                clearHeader: clearHeader
            }} >
            {props.children}
        </HeaderContext.Provider>
    )
}

const HeaderConsumer = HeaderContext.Consumer;

export { HeaderProvider, HeaderConsumer };